import React, { useRef } from "react";
import Hero from "./hero";
import WhatsNew from "./whatsNew";
import EmpoweringSuccess from "./EmpoweringSuccess/EmpoweringSuccess";
import Accreditation from "./Accreditations/Accreditations";
import image3 from "../../assets/homePage/logos/Ofqual_logo_2018.svg.png";
import image1 from "../../assets/homePage/logos/m2hse-proqual.jpeg";
import image2 from "../../assets/homePage/logos/citb.jpg";
import { Helmet } from "react-helmet";
<link rel="canonical" href="https://m2hse.co.uk/" />;

const images = [image1, image2, image3];

const Home = () => {
  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div>
      <Helmet>
        {/* Facebook Meta Tags */}
        <meta property="og:title" content="M2HSE Training" />
        <meta
          property="og:description"
          content="M2HSE Training is your career navigator for learning. Access accredited courses, Certifications, NVQs, and workplace training across every industry."
        />
        <meta
          property="og:image"
          content="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTDPj_GGmVNKL-7-8vcxfJB8m6EZ_gKcc41Xw&s"
        />
        <meta property="og:url" content="https://m2hse.co.uk" />
        <meta property="og:site_name" content="M2HSE Training" />
        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="M2HSE Training" />
        <meta
          name="twitter:description"
          content="M2HSE Training is your career navigator for learning. Access accredited courses, Certifications, NVQs, and workplace training across every industry."
        />
        <meta
          name="twitter:image"
          content="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTDPj_GGmVNKL-7-8vcxfJB8m6EZ_gKcc41Xw&s"
        />
      </Helmet>
      <Hero onEnquireClick={scrollToContact} />
      <WhatsNew />
      <EmpoweringSuccess />
      <Accreditation images={images} />
      {/* <Blogs /> */}
      {/* <ReviewStories /> */}
      <div className=" py-6 px-4 sm:px-8 shadow-lg bg-[#0C1524] mx-auto max-w-7xl">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 text-center">
          See What Our Customers Say
        </h2>
        <div
          class="trustpilot-widget"
          data-locale="en-GB"
          data-template-id="53aa8912dec7e10d38f59f36"
          data-businessunit-id="65e09121938229973209b5ac"
          data-style-height="140px"
          data-style-width="100%"
          data-theme="dark"
          data-stars="1,2,3,4,5"
          data-review-languages="en">
          <a
            href="https://uk.trustpilot.com/review/m2hse.co.uk"
            target="_blank"
            rel="noopener noreferrer">
            Trustpilot
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
